module.exports = __webpack_public_path__ + "images/emoji/libra.67a4f66c3790d6de4ead.png";